enum LocalStorageTypes {
  EntryTableRows = 'EntryTableRows',
  CostTableRows = 'CostTableRows',
  ProjectTableRows = 'ProjectTableRows',
  UsersTableRows = 'UsersTableRows',
  ReportsTableRows = 'ReportsTableRows',
  CandidatesTableRows = 'CandidatesTableRows',
  RecruitmentsTableRows = 'RecruitmentsTableRows',
  DemandsTableRows = 'DemandsTableRows',
  CostSummaryRows = 'CostSummaryRows',
  TechStackRows = 'TechStackRows',
  RolesRows = 'RolesRows',
  PermissionsRows = 'PermissionsRows',
  DictionariesRows = 'DictionariesRows',
  TeamTableRows = 'TeamTableRows'
}

export default LocalStorageTypes